import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { a as n } from "../../../../index-CROKJrb5.js";
import { c, f as p } from "../../../../create-component-CBAeEoQ6.js";
import { RadioButtonGroup as u } from "../../../RadioButton/RadioButtonGroup/index.js";
import { ListHeader as d } from "../../../ListHeader/index.js";
const R = c(
  "ControlCardRadioButtonGroup",
  p(
    ({ as: r, children: t, className: a, title: e, ...s }, m) => {
      const i = r || "div";
      return /* @__PURE__ */ o.jsxs(i, { className: n("cur-relative cur-z-10 cur-mb-0", a), children: [
        /* @__PURE__ */ o.jsx(d, { headerTitle: e, className: "cur-mb-3" }),
        /* @__PURE__ */ o.jsx(u, { ref: m, ...s, children: t })
      ] });
    }
  )
);
export {
  R as ControlCardRadioButtonGroup
};
//# sourceMappingURL=index.js.map
